/**
 * @param {String} name
 *
 * @return {boolean}
 */
export function getCookie(name: string) {
    const match = document.cookie.match(
        new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? match[0].split('=')[1] : false;
}

/**
 * @param {String} name
 * @param {String|Number} value
 * @param {?Number} exdays
 * @param {?String} domain
 */
export function setCookie(
    name: string,
    value: string | number,
    exdays?: number | Date,
    domain?: string,
    path?: string
) {
    let params = [];

    if (exdays) {
        let date = new Date();
        if (exdays instanceof Date) {
            date = exdays;
        } else {
            date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
        }
        params.push('expires=' + date.toUTCString());
    }

    if (domain) {
        params.push('domain=' + domain);
    }

    if (path) {
        params.push('path=' + path);
    }

    document.cookie = `${name}=${value}; ${params.join('; ')}`;
}
